                <!-- SETUP NEW COMPONENT -->
<ng-container *ngIf="backgroundItems">

  <p>{{item.value.position | translation}}</p>
  <div class="thumbnail-wrapper" *ngIf="item.value.backgroundList?.length > 0" #rowLayout cdkDropListGroup>

    <div fxLayout="row"
         *ngFor="let itemsRow of getItemsTable(rowLayout)"
         cdkDropList
         cdkDropListOrientation="horizontal"
         [cdkDropListData]="itemsRow"
         (cdkDropListDropped)="drop($event)">
      <div matRipple
           cdkDrag
           [matMenuTriggerFor]="menuSplitBackground"
           *ngFor="let img of itemsRow; let i = index"
           class="thumbnail-content"
           fxLayout="column" fxLayoutAlign="space-around center">

        <!-- <button class="button-icon" mat-button [matMenuTriggerFor]="menu">
          <mat-icon>settings</mat-icon>
        </button> -->
        <mat-menu #menuSplitBackground="matMenu">
          <button mat-menu-item (click)="setActiveBackground(img, item.key)">{{'activate' | translation }}</button>
          <button mat-menu-item (click)="removeBackground(img, item.key)"> {{'delete' | translation }}</button>
        </mat-menu>

        <span class="badge" *ngIf="img.active" matBadge="✔" matBadgeOverlap="true"></span>

        <!-- <i *ngIf="img == sharedService.configForm.backgroundURL " class="material-icons" id="activeBackground">
          done
        </i> -->
        <!-- IF IS AN IMAGE -->
        <img *ngIf="(img.url  | mapFileName) == 'jpg' || (img.url | mapFileName) == 'png'"
             class="image-thumbnail thumbnail"
             [src]="img.url " poster="" />
        <!-- IF IS A VIDEO -->
        <div fxLayout="column" fxLayoutAlign="center center" class="video-thumbnail thumbnail"
             *ngIf="(img.url | mapFileName) == 'video'">
          <mat-icon>video_library</mat-icon>

        </div>

        <!-- TITLE -->
        <p class="overflow-ellipsis thumbnail-label"
           [style.font-size.px]="stylingService.getFontSize('small')"
           *ngIf="sharedService.urlToNameArray[i] != undefined">{{getNameFromUrl(img.url)}}</p>


      </div>

    </div>




    <section class="card-section" fxLayout="column" fxLayoutAlign="flex-start flex-start">
      <div class="form-group" id="galleryEnable">
        <mat-slide-toggle color="accent" type="checkbox" (change)="changeValue()" name="galleryEnable"
                          [(ngModel)]="item.value.galleryEnable">
          {{'activateSlideshow' | translation}}
        </mat-slide-toggle>
      </div>

      <div *ngIf="item.value.galleryEnable">
        <mat-form-field autocomplete="off">
          <input matInput placeholder="Délai de transition (en sec)" (change)="changeValue()" type="number"
                 [(ngModel)]="item.value.timerSlideshow" matInputclass="form-control" id="timerSlideshow"
                 name="timerSlideshow">
        </mat-form-field>
      </div>

    </section>
  </div>
</ng-container>
